import { render, staticRenderFns } from "./Personnel.vue?vue&type=template&id=387dacaa&scoped=true&"
import script from "./Personnel.vue?vue&type=script&lang=ts&"
export * from "./Personnel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387dacaa",
  null
  
)

export default component.exports